import { VideoIngestorVideoStatus, VideoStatusType } from "libs/apiClient";
import { formatApiStatus } from "../functions";

const extraIngestorApiStatuses = ["detected", "waiting_for_stitching"] as const;

function toApiStatusFilterOption(value: string) {
	return {
		value,
		label: formatApiStatus(value) ?? value,
	};
}

export const apiStatusFilterOptions = [
	...Object.values(VideoStatusType.Values).map(toApiStatusFilterOption),
	...Object.values(VideoIngestorVideoStatus.Values).map(toApiStatusFilterOption),
	...extraIngestorApiStatuses.map(toApiStatusFilterOption),
];

export const videoProcessingStatusFilterValues = new Set<string>(Object.values(VideoStatusType.Values));
